import Vue from 'vue'
import App from '~/App.vue'
import router from '~/router'
import Plugins from '~/plugins/vant'
import { initFontSize } from '~/utils/tools'
import '~/assets/styl/base.styl'

Vue.use(Plugins)
Vue.config.productionTip = false

new Vue({
  router,
  mounted () {
    initFontSize()
  },
  render: h => h(App),
}).$mount('#app')
